// (function() {
//     'use strict';

//     angular.module("imApp").factory("campaignProductsService", [function() {
//         let service = {};

//         return service;
//     }]);
// })();
